import React from 'react';
import { CheckIcon, HandIcon, RefreshCcwIcon, SignpostIcon } from 'lucide-react';
import { SectionCta } from './SectionCta';
import { volumes } from '../data/content';
const protocolIcons = [HandIcon, RefreshCcwIcon, SignpostIcon];
const protocolColors = ['bg-alert', 'bg-amber-500', 'bg-cta'];
export function Volumes() {
  return <section className="bg-canvas px-5 py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-342" data-mp="1c606t12lgq74">
      <div className="mx-auto max-w-4xl" data-id="element-343" data-mp="1zwcp95vgu5by">
        <h2 id="volumes-title" className="text-center font-display text-4xl font-bold uppercase leading-tight text-navy-900 sm:text-5xl" data-id="element-344" data-mp="24u5unwoy2vb6">
          What you'll find inside <span className="text-radar-deep" data-id="element-345" data-mp="1qwplwej6epg9">Implant Risk Radar™</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-lg text-muted" data-id="element-346" data-mp="1vrmwhpw3t6v9">
          Six volumes, each built around one moment of the implant journey — from planning to the difficult case.
        </p>

        <div className="mt-12 space-y-6" data-id="element-347" data-mp="kc7x6fgfa2wz">
          {volumes.map(v => <article key={v.numeral} className={`overflow-hidden rounded-3xl bg-white ${v.core ? 'ring-2 ring-radar' : 'ring-1 ring-navy-900/10'}`} data-id="element-348" data-mp="3o8ose0gw3ktp">
              <div className="flex items-center gap-4 bg-navy-900 px-6 py-5" data-id="element-349" data-mp="21q7y7c5quwi">
                <span className="font-display text-5xl font-bold leading-none text-radar" data-id="element-350" data-mp="3t701g8zd1rav">{v.numeral}</span>
                <div data-id="element-351" data-mp="b0lczg3gtyy8">
                  <p className="text-xs font-bold uppercase tracking-widest text-white/60" data-id="element-352" data-mp="b027wzywz51m">
                    Volume {v.numeral}
                    {v.core && <span className="ml-2 rounded bg-radar px-1.5 py-0.5 text-navy-950" data-id="element-353" data-mp="krg9ddafeexe">Core</span>}
                  </p>
                  <h3 className="mt-1 font-display text-2xl font-semibold uppercase leading-tight text-white" data-id="element-354" data-mp="fs3ec59ei1jq">
                    {v.title}
                  </h3>
                </div>
              </div>

              <div className="p-6 sm:p-8" data-id="element-355" data-mp="prc74usj5a4i">
                <div className="space-y-3 text-[17px] leading-relaxed text-ink" data-id="element-356" data-mp="pog7n211addy">
                  {v.intro.map(p => <p key={p} data-id="element-357" data-mp="11stzrvdwc2vm">{p}</p>)}
                </div>

                {v.protocol && <ol className="mt-6 grid gap-3 sm:grid-cols-3" data-id="element-358" data-mp="16rdmhy0bdip1">
                    {v.protocol.map((step, i) => {
                const Icon = protocolIcons[i];
                return <li key={step.step} className="rounded-2xl bg-canvas p-4" data-id="element-359" data-mp="1fl0dzbxhnzsf" data-mpi={i}>
                          <span className={`flex h-11 w-11 items-center justify-center rounded-full ${protocolColors[i]}`} data-id="element-360" data-mp="1kj1y806ni55h">
                            <Icon className="h-5 w-5 text-white" aria-hidden="true" data-id="element-361" data-mp="1pgka9zfyt0hp" />
                          </span>
                          <p className="mt-3 font-display text-2xl font-bold text-navy-900" data-id="element-362" data-mp="3ra1e0s0z5h76">{step.step}</p>
                          <p className="mt-1 text-[15px] leading-snug text-muted" data-id="element-363" data-mp="2ykhtxnyyts">{step.text}</p>
                        </li>;
              })}
                  </ol>}

                <p className="mt-6 text-sm font-bold uppercase tracking-wider text-radar-deep" data-id="element-364" data-mp="28mrplfxe5s6x">Includes:</p>
                <ul className="mt-3 grid gap-2.5 sm:grid-cols-2" data-id="element-365" data-mp="24mhmqc4wbhwa">
                  {v.includes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-366" data-mp="1znmw4o0osp1m">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-367" data-mp="2wcvvxv1ys61m" />
                      <span className="text-[16px] font-medium leading-snug text-ink" data-id="element-368" data-mp="2scby0p9kgyef">{item}</span>
                    </li>)}
                </ul>

                {v.note && <p className="mt-6 rounded-xl bg-radar-light p-4 text-[16px] font-medium italic leading-relaxed text-navy-900" data-id="element-369" data-mp="2ibru1eunxfsi">
                    {v.note}
                  </p>}
              </div>
            </article>)}
        </div>

        <SectionCta label="I want all 6 volumes now" data-id="element-370" data-mp="2uum38ctg8ap0" />
      </div>
    </section>;
}